import { Suspense, lazy } from 'react'
import { RouteFallback } from '@/shared/components/RouteFallback'

const LazyProtectedAppLayout = lazy(() =>
  import('@/app/ProtectedAppLayout').then((m) => ({ default: m.ProtectedAppLayout })),
)

/** Suspense above the protected shell - AppLayout's Outlet Suspense only covers nested pages. */
export function SuspendedProtectedAppLayout() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <LazyProtectedAppLayout />
    </Suspense>
  )
}
